import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import VendorsQueryPayload from "../../types/taxonomy";
import { VENDOR_ID_QUERY } from "../../apis/taxonomy/queries";
import { TAXONOMY_CLIENT } from "../../utils/consts";

const vendorDataToNameMap = (
  vendors: VendorsQueryPayload["vendor"]["data"] | undefined
): Record<string, string> => {
  if (!vendors) return {};

  return vendors.reduce(
    (acc, vendor) => {
      if (vendor && vendor.id && vendor.name) {
        acc[String(vendor.id)] = vendor.name;
      }
      return acc;
    },
    {} as Record<string, string>
  );
};

export const useSimpleVendorsLabel = (vendorIds: number[]): string => {
  const { data: vendorQueryData, loading: vendorsLoading } =
    useQuery<VendorsQueryPayload>(VENDOR_ID_QUERY, {
      variables: {
        ids: vendorIds,
      },
      skip: vendorIds.length === 0,
      context: {
        clientName: TAXONOMY_CLIENT,
      },
    });

  const nameMap = useMemo(
    () => vendorDataToNameMap(vendorQueryData?.vendor.data),
    [vendorQueryData]
  );

  if (vendorIds.length > 0 && vendorsLoading) {
    return "Loading...";
  }

  if (vendorIds.length === 0) {
    return "All";
  }

  if (vendorIds.length === 1) {
    return nameMap[vendorIds[0]] || "1 selected";
  }

  return `${vendorIds.length} selected`;
};
